<template>
  <div
    class="question-details-wrapper"
    :class="question.precondition ? 'follow-up' : ''"
  >
    <div
      class="question-card card d-flex flex-column justify-content-between h-100 pt-10 mb-10"
    >
      <LoadingSpinner />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionDetailsLoading',
  props: {
    question: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.question-details-wrapper {
  height: 100%;
  &.follow-up {
    margin-top: 10px;
    height: calc(100% - 10px);
    .question-card {
      background-color: rgba(var(--kt-gray-200-rgb), 0.5);
    }
  }
}

.question-card {
  background-color: rgba(var(--kt-gray-100-rgb), 0.4);
}
</style>
